/* @ngInject */ export function StoreAdminServiceProvider() {
  /**
   * @ngdoc property
   * @name  StoreAdminServiceProvider#httpServiceBase
   * @description
   * Server side controller URL.
   */
  this.httpServiceBase = '/books/storeAdmin/';

  /**
   * @ngdoc property
   * @name  StoreAdminServiceProvider#httpServices
   * @description
   * Server side service methods.
   */
  this.httpServices = (http) => ({
    load: () => http.get('load'),
    save: (data) => http.post('save', data)
  });

  this.$get = ['HTTPService', function (HTTPService) {
    return HTTPService.make(this.httpServiceBase, this.httpServices);
  }];
}
